import { removeCookieCSR } from '@/app/api/CSR/Cookies'

export const removeSessionStorage = (select: string): void => {
  sessionStorage?.removeItem(select)
}

export const removeLocalStorage = (select: string): void => {
  localStorage?.removeItem(select)
}

export const removeStored = (selections: string[]): void => {
  selections.forEach((select) => {
    removeSessionStorage(select)
    removeLocalStorage(select)
    removeCookieCSR(`_IL-${select}`)
  })
}
